import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { TriggersTable } from 'widgets/TriggerList/ui/TriggersTable/TriggersTable'
import { FiltersAndSearch } from 'widgets/FiltersAndSearch'
import { useTriggerListContext } from 'widgets/TriggerList/context/context'
import { TriggersHeader } from 'widgets/TriggerList/ui/TriggersHeader/TriggersHeader'
import { EmptyStateTriggers } from './EmptyStateTriggers'
import styles from './styles.module.scss'

export enum EnumTypeTrigger {
  all = 'All',
  sms = 'SMS',
  ringless = 'Ringless',
  rcs = 'RCS',
}

export const TriggerListContent = observer(() => {
  const [parent, setParent] = useState<HTMLDivElement | null>(null)
  const {
    filtersAndSearchStore,
    isTriggersEmpty,
    type,
    pageLayoutStore,
    isFirstLoading,
    initTriggersLoad,
  } = useTriggerListContext()

  useEffect(() => {
    void initTriggersLoad()
  }, [])

  if (isTriggersEmpty) {
    return <EmptyStateTriggers />
  }

  if (isFirstLoading) {
    return <SpinnerLoader ariaLabel={'TriggerListContent'} />
  }

  return (
    <>
      <TriggersHeader
        title={`Triggers: ${EnumTypeTrigger[type]}`}
        pageLayoutStore={pageLayoutStore}
        isTriggersEmpty={isTriggersEmpty}
      />
      <div ref={setParent} className={styles.triggerListContentContainer}>
        <FiltersAndSearch store={filtersAndSearchStore} parent={parent} />
        <TriggersTable />
      </div>
    </>
  )
})
